import FormattedMessage from 'I18n/components/FormattedMessage';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { useFilterConfig } from '../../hooks/useFilterConfig';
import { ToggleFilter } from '../reusableFilters/ToggleFilter';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function RequiredAppsInstalledFilter() {
  const {
    REQUIRED_APPS_INSTALLED
  } = useFilterConfig();
  if (!REQUIRED_APPS_INSTALLED) return null;
  return /*#__PURE__*/_jsxs(Flex, {
    alignItems: "center",
    gap: "400",
    justifyContent: "space-between",
    children: [/*#__PURE__*/_jsx(Text, {
      as: "label",
      htmlFor: REQUIRED_APPS_INSTALLED.field,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "marketplaceStorefront.filters.workflowTemplate.requiredAppsInstalled.label"
      })
    }), /*#__PURE__*/_jsx(ToggleFilter, {
      filter: REQUIRED_APPS_INSTALLED
    })]
  });
}